export default "__VITE_ASSET__044f1ea9__"